export default __webpack_public_path__ + "static/media/fastingbreak@3x.9dacfea4.jpg";